import {useRef, useState} from 'react';
import useDrag from '../../../hooks/useDrag';
import numberInRange from '../../../utils/numberUtils/numberInRange';

function useModalDrag(modalWidth: string) {
  const [position, setPosition] = useState({x: 0, y: 0});
  const dragStart = useRef({x: 0, y: 0});

  const {handleDragStart} = useDrag({
    onDragStart({clientX, clientY}) {
      dragStart.current = {x: position.x - clientX, y: position.y - clientY};
    },
    handleMove({clientX, clientY}) {
      const halfWidth = (window.innerWidth - (parseInt(modalWidth) || 400)) / 2,
        halfHeight = (window.innerHeight - 300) / 2;
      setPosition({
        x: numberInRange(clientX + dragStart.current.x, -halfWidth, halfWidth),
        y: numberInRange(clientY + dragStart.current.y, -halfHeight, halfHeight),
      });
    },
  });

  return {
    handleDragStart,
    modalPositionStyle: {
      position: 'relative',
      top: `${position.y}px`,
      left: `${position.x}px`,
    },
  };
}

export default useModalDrag;
